import React from "react";
import { Row,Col } from "react-bootstrap";
import Package from "../../../../package.json";

class Footer extends React.Component {
  render() {
    return (
      <Row className="copyright ms-1">
        <Col xs={12} className="d-flex justify-content-between">
          <small>
            Copyright © 2021-
            {new Date().getUTCFullYear()}, BRITEX-CZ, s.r.o.
          </small>
          <small>Verze {Package.version}</small>
        </Col>
      </Row>
    );
  }
}

export default Footer;
